import React from "react";

/**
 * The toggle visual — track and thumb only, no button semantics.
 *
 * Kept presentational on purpose: the cab wraps a whole settings row in the switch button so the
 * touch target is the row, while the console makes just the control clickable. Both need the same
 * drawing with different hit areas, so the semantics (role="switch", aria-checked, onClick) belong
 * to the wrapping button.
 */
export const Switch: React.FC<{ on: boolean; className?: string }> = ({ on, className = "" }) => (
    <span
        className={`relative inline-block h-7 w-[46px] flex-none rounded-full transition-colors ${
            on ? "bg-[var(--safe)]" : "bg-[var(--surface-3)]"
        } ${className}`}
    >
        <span
            className={`absolute left-[3px] top-[3px] h-[22px] w-[22px] rounded-full bg-white shadow transition-transform ${
                on ? "translate-x-[18px]" : ""
            }`}
        />
    </span>
);
